/** Formatadores locais de GAM > Anunciantes (complementam o fmt da Dashboard). */

export const UNKNOWN_COUNTRY = 'Não informado';

const USD = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD' });
const NUM = new Intl.NumberFormat('pt-BR');

export const fmtAdv = {
    usd: (v: number | null | undefined) => USD.format(v || 0),
    num: (v: number | null | undefined) => NUM.format(v || 0),
    pct: (v: number | null | undefined) => (v == null ? '—' : `${v.toFixed(2)}%`),
    pct1: (v: number | null | undefined) => (v == null ? '—' : `${v.toFixed(1)}%`),
    date: (iso: string) => {
        const [y, m, d] = String(iso || '').split('-');
        return y && m && d ? `${d}/${m}/${y}` : iso;
    },
    dayMonth: (iso: string) => {
        const [, m, d] = String(iso || '').split('-');
        return m && d ? `${d}/${m}` : iso;
    },
};

export interface DeltaChip {
    value: string;
    positive: boolean;
    title?: string;
}

/**
 * Chip de variação a partir do delta_pct que o backend já calculou.
 * null (sem base de comparação) e 0 (sem variação) → sem chip.
 * `invert` para métricas em que subir é ruim (não usado por padrão).
 */
export function deltaChip(pct: number | null | undefined, title?: string, invert = false): DeltaChip | undefined {
    if (pct == null || !Number.isFinite(pct) || pct === 0) return undefined;
    const sign = pct > 0 ? '+' : '';
    const positive = invert ? pct < 0 : pct > 0;
    return { value: `${sign}${pct.toFixed(1).replace('.', ',')}%`, positive, title };
}

/** Variação de posição no ranking (+ subiu, − caiu). */
export function rankChip(change: number | null | undefined): DeltaChip | undefined {
    if (change == null || change === 0) return undefined;
    return { value: `${change > 0 ? '+' : ''}${change} pos.`, positive: change > 0, title: 'Posição vs período anterior' };
}

/** Rótulo do bloco: ad unit igual ao domínio = impressão do nível superior. */
export function adUnitLabel(adUnit: string | undefined, domain: string | undefined): string {
    if (!adUnit) return '—';
    return adUnit === domain ? `${adUnit} (nível superior)` : adUnit;
}
